import type { MediaCandidates, MediaOptions } from 'js/src/client';
import type { ImmutableMap } from 'js/src/libs/consts';
import type { RootState } from 'js/src/libs/RootState';

export function getSourceSegmentForScene(
    state: RootState,
    sceneId: string | null,
): string | undefined {
    if (!sceneId) return undefined;
    return state.recommendations.source_segment_per_rephrased_scene[sceneId];
}

export function getDatasetMetadata(state: RootState) {
    return state.recommendations.dataset_metadata;
}

export function getRecommendedVideoResponseMediaOptions(
    state: RootState,
): ImmutableMap<MediaOptions> | null {
    if (!state.recommendations?.recommendedVideoResponse) {
        return null;
    }
    return state.recommendations.recommendedVideoResponse.get('media_options');
}

export function getRecommendedVideoResponseMediaCandidates(
    state: RootState,
): ImmutableMap<MediaCandidates> | null {
    if (!state.recommendations?.recommendedVideoResponse) {
        return null;
    }
    return state.recommendations.recommendedVideoResponse.get('media_candidates');
}

/**
 * Helper function to safely extract MediaCandidates from Redux state for agent use.
 * Returns null if no media candidates are available.
 */
export function getMediaCandidatesForAgent(state: RootState): MediaCandidates | null {
    const immutableCandidates = getRecommendedVideoResponseMediaCandidates(state);
    if (!immutableCandidates) {
        return null;
    }

    // Convert ImmutableMap to plain object
    try {
        return immutableCandidates.toJS();
    } catch (error) {
        return null;
    }
}
